module.exports = __webpack_public_path__ + "static/media/banner-novo.b441dbf5.png";